import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import "./PressStatements.css";

export default function PressStatements() {
  const [pressData, setPressData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await getContentById("pressStatements");
    setPressData(data);
  };

  return (
    <div className="PressStatements">
      <div className="color"></div>
      <div className="pressLogo">
        <img src="assets/image 17.png" alt="" />
      </div>
      <div className="pressBody">
        <div className="left-press">
          <h1>Press Statements</h1>
          <hr />
          <div className="press-data">
            {pressData?.map((data) => (
              <div key={data.id}>
                <h1>{data.title}</h1>
                <p>{data.subTitle}</p>
                <br />
              </div>
            ))}
            <hr />
          </div>
        </div>
        <div className="right-press">
          <img src="assets/imam-PS.jpg" alt="" />
        </div>
      </div>
      <hr />
      <div className="pressBottom">
        <div className="leftBottom">
          <h1>ALLAHUMMA INNI AS’ALUKA</h1>
          <br />
          <p>
            اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا
            وَالآخِرَةِ
          </p>
        </div>
        <div className="rightBottom">
          <p>
            Transliteration: Allahumma inni as’alukal-‘afwa wal-‘afiyah
            fid-dunya wal-akhirah
          </p>
          <p>
            English Meaning / Translation: O Allah, I ask You for forgiveness
            and well-being in this world and in the Hereafter.
          </p>
        </div>
      </div>
    </div>
  );
}
